import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Griddle from 'griddle-react';
import GriddlePagingRP from './Pagination';
import ColumnPrice from './ColumnPrice';
import ColumnStallionName from './ColumnStallionName';
import ColumnSireName from './ColumnSireName';
import ColumnSireLine from './ColumnSireLine';
import HeaderYearToStud from './HeaderYearToStud';
import NoDataComponent from './NoDataComponent';
import FailedRequestComponent from './FailedRequestComponent';
import ColumnShared from './ColumnShared';
import Spinner from '../Spinner';
import mapSortColumns from './ColumnSortMapper';
import { scroll } from '../../utils/scrollHelper';
import Svg from 'rp-react-svg-icon';

const columnsData = [
    {
        columnName: 'style_name',
        displayName: 'STALLION NAME',
        customComponent: ColumnStallionName,
        sortDirectionCycle: ['asc']
    },
    {
        columnName: 'stud_name',
        displayName: 'STANDING',
        customComponent: ColumnShared,
        sortDirectionCycle: ['asc']
    },
    {
        columnName: 'stud_country_code',
        displayName: 'CTRY',
        customComponent: ColumnShared,
        sortDirectionCycle: ['asc'],
        cssClassName: 'hidden-sm-down'
    },
    {
        columnName: 'stud_fee',
        displayName: 'STUD FEE',
        customComponent: ColumnPrice,
        sortDirectionCycle: ['desc']
    },
    {
        columnName: 'sire_style_name',
        displayName: 'SIRE',
        customComponent: ColumnSireName,
        sortDirectionCycle: ['asc'],
        cssClassName: 'hidden-sm-down'
    },
    {
        columnName: 'sire_line_style_name',
        displayName: 'SIRE LINE',
        customComponent: ColumnSireLine,
        sortDirectionCycle: ['asc'],
        cssClassName: 'hidden-sm-down'
    },
    {
        columnName: 'year_to_stud',
        displayName: 'YEAR TO STUD',
        customHeaderComponent: HeaderYearToStud,
        customComponent: ColumnShared,
        sortDirectionCycle: ['desc']
    }
].map((col, i) => Object.assign({}, col, {
    order: i + 1,
    locked: false,
    visible: true,
    multiSort: { columns: ['style_name'], orders: ['asc'] },
    cssClassName: `ui-table__cell ${col.cssClassName ? col.cssClassName : ''}`
}));

const columns = columnsData.map(c => c.columnName);

const rowMetaData = { bodyCssClassName: 'ui-table__row' };

const RESULTS_PER_PAGE = 36;
class GriddleRP extends PureComponent {
    render() {
        const results = mapSortColumns(this.props.results);

        const tableClassName =
            `ui-table ui-table_sortable ui-table_type1 ${this.props.isFetching ? 'fetching' : ''}`;

        let enableSort = true;
        let sortAscendingClassName = 'ui-table__cell_sorted';
        let sortDescendingClassName = 'ui-table__cell_sorted';

        if (!(results.length > 1) && !(this.props.isFetching)) {
            sortAscendingClassName = '';
            sortDescendingClassName = '';
        }

        const visibleColumns = results.length ? columns : [];
        const visibleColumnsMeta = results.length ? columnsData : {};

        return (
            <Griddle
                sortAscendingClassName={sortAscendingClassName}
                sortDescendingClassName={sortDescendingClassName}
                rowMetadata={rowMetaData}
                useGriddleStyles={false}
                tableClassName={tableClassName}
                results={results}
                resultsPerPage={RESULTS_PER_PAGE}
                columns={visibleColumns}
                columnMetadata={visibleColumnsMeta}
                initialSort="style_name"
                useCustomPagerComponent
                customPagerComponent={(pager) => {
                    return (<GriddlePagingRP
                        className="pager__controls"
                        currentPage={pager.currentPage + 1}
                        totalCount={results.length}
                        pageSize={RESULTS_PER_PAGE}
                        onPageChange={index => pager.setPage(index - 1)}
                    />)
                }}
                customNoDataComponent={
                    this.props.requestFailed ? FailedRequestComponent : NoDataComponent
                }
                externalLoadingComponent={Spinner}
                externalIsLoading={this.props.isFetching}
                enableSort={enableSort}
                sortAscendingComponent={<Svg iconName={'upArrowStandard'} style={{ marginLeft: '4px'}} size={'XSmall'} />}
                sortDescendingComponent={<Svg iconName={'upArrowStandard'} style={{marginLeft: '4px'}} size={'XSmall'} className={'arrow180'} />}
            />
        );
    }
}

GriddleRP.propTypes = {
    results: PropTypes.array,
    isFetching: PropTypes.bool,
    requestFailed: PropTypes.bool
};
export default GriddleRP;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/index.js